import React from "react";
import {
  FaGithubSquare,
  FaFacebookSquare,
  FaLinkedin,
  FaTwitterSquare,
  FaDiscord,
  FaInstagramSquare,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="relative pb-72 bg-gray-light/10">
      <div className="lg:w-[65%] md:w-[85%] mx-auto sm:w-[90%] w-[90%] bg-[#1d1836] footer py-4 px-10 rounded -top-28 lg:left-[17.5%] md:left-[7.5%] sm:left-[5%] left-[5%] absolute">
        <div>
          <h4 className="text-blue tex-lg font-poppins font-bold">THANKS</h4>
          <p className="lg:text-2xl md:text-2xl text-xl text-gray mb-10 font-poppins">
            Let's build something together 👨‍💻
            {/* <img className='w-7' src={build} alt="Creating" /> */}
          </p>
        </div>
        <div
          className="bg-gray-light/10 p-10 flex flex-col lg:flex-row md:flex-row justify-center lg:gap-x-56 md:gap-x-32 gap-y-5"
          style={{ fontFamily: "'Kanit', sans-serif" }}
        >
          <div className="">
            <h4 className="text-blue font-poppins font-semibold">
              khubaibul.dev
            </h4>
            <p className="text-sm font-mulish font-medium text-secondary">
              Developing reliable web applications since 2021
            </p>
          </div>
          <div className="">
            <h4 className="text-blue font-poppins font-semibold">Social</h4>
            <div className="grid grid-flow-col lg:gap-4 md:gap-4 sm:gap-3 gap-2 text-2xl">
              <a
                className="hover:text-blue duration-300"
                rel="noreferrer"
                target="_blank"
                href="https://github.com/khubaibul"
              >
                <FaGithubSquare />
              </a>
              <a
                className="hover:text-blue duration-300"
                rel="noreferrer"
                target="_blank"
                href="https://www.linkedin.com/in/khubaibul-islam"
              >
                <FaLinkedin />
              </a>
              <a
                className="hover:text-blue duration-300"
                rel="noreferrer"
                target="_blank"
                href="https://https://discordapp.com/users/1007329652106334279"
              >
                <FaDiscord />
              </a>
              <a
                className="hover:text-blue duration-300"
                rel="noreferrer"
                target="_blank"
                href="https://www.facebook.com/khubaibulislamshakib.xx"
              >
                <FaFacebookSquare />
              </a>
              <a
                className="hover:text-blue duration-300"
                rel="noreferrer"
                target="_blank"
                href="https://twitter.com/KI_Shakib2001"
              >
                <FaTwitterSquare />
              </a>
              <a
                className="hover:text-blue duration-300"
                rel="noreferrer"
                target="_blank"
                href="https://www.instagram.com/ki_shakib"
              >
                <FaInstagramSquare />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
